import React from 'react'
import SEOHead from '@/components/SEO/SEOHead'
import { buildGraph, breadcrumbListData, serviceSchema, faqData } from '@/data/structured-data'
import PageHeader from '@/components/Common/PageHeader'
import ArticleBody from '@/components/Content/ArticleBody'
import { rontgenContent } from '@/data/landing-content'
import { Link } from 'react-router-dom'
import { contactInfo } from '@/data/contact'
import { toTelHref, toWhatsAppHref } from '@/utils/phone'

const RontgenFiyatlariPage: React.FC = () => {
  const telHref = toTelHref(contactInfo.phone)
  const waHref = toWhatsAppHref(contactInfo.whatsapp)

  return (
    <>
      <SEOHead
        title="Veteriner Röntgen Fiyatları | Şanlıurfa"
        description="Şanlıurfa'da dijital röntgen ve ultrason. Hangi durumda hangi görüntüleme gerekir, sedasyon şart mı, fiyatı ne belirler? Aynı gün değerlendirme."
        keywords="veteriner röntgen fiyatları, hayvan röntgen, şanlıurfa veteriner röntgen, dijital röntgen DR"
        canonicalUrl="/rontgen-fiyatlari"
        structuredData={buildGraph(
          serviceSchema({
            name: 'Veteriner Dijital Röntgen (DR)',
            description: 'Dijital röntgen ile hızlı ve net görüntüleme; bölge ve poz sayısına göre fiyatlandırma, aynı gün değerlendirme.',
            url: '/rontgen-fiyatlari',
            serviceType: 'Tıbbi görüntüleme'
          }),
          faqData(rontgenContent.faqs),
          breadcrumbListData([
            { name: 'Ana Sayfa', url: '/' },
            { name: 'Röntgen Fiyatları', url: '/rontgen-fiyatlari' }
          ])
        )}
      />
      <PageHeader
        title="Röntgen ve Görüntüleme"
        subtitle="Dijital DR ile saniyeler içinde sonuç. Fiyat, çekilecek bölgeye ve poz sayısına göre belirlenir."
      />

      <section className="section-padding">
        <div className="container-custom grid grid-cols-1 lg:grid-cols-3 gap-10">
          <article className="lg:col-span-2">
            <ArticleBody
              intro={rontgenContent.intro}
              sections={rontgenContent.sections}
              faqs={rontgenContent.faqs}
              disclaimer="Bu sayfa bilgilendirme amaçlıdır. Hangi görüntülemenin gerekli olduğuna muayene sonrası karar verilir; işlem öncesinde tutar size bildirilir."
            />
          </article>

          <aside className="space-y-6">
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 lg:sticky lg:top-24">
              <h3 className="font-bold text-gray-900 mb-2">Fiyat bilgisi alın</h3>
              <p className="text-sm text-gray-600 mb-4">
                Şikâyeti anlatın, hangi görüntülemenin gerekebileceğini ve tahmini tutarı telefonda paylaşalım.
              </p>
              <a href={telHref} className="btn-primary w-full inline-flex items-center justify-center mb-2">
                {contactInfo.phone}
              </a>
              <a
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary w-full inline-flex items-center justify-center"
              >
                WhatsApp
              </a>
            </div>

            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6">
              <h3 className="font-bold text-gray-900 mb-3">İlgili sayfalar</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/hizmetler/goruntuleme-hizmetleri" className="text-primary-700 hover:underline">Görüntüleme hizmetleri</Link></li>
                <li><Link to="/klinik/tibbi-goruntuleme" className="text-primary-700 hover:underline">Tıbbi görüntüleme birimi</Link></li>
                <li><Link to="/acil-veteriner" className="text-primary-700 hover:underline">Acil veteriner</Link></li>
                <li><Link to="/hizmetler/cerrahi" className="text-primary-700 hover:underline">Cerrahi</Link></li>
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </>
  )
}

export default RontgenFiyatlariPage


